
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import React from 'react';
import Divider from '@material-ui/core/Divider';
import { IProductData } from 'interfaces/IProductData';
import { cartService } from 'services/CartService';
import { paymentService } from 'services/PaymentService';
import { ICartModel } from 'interfaces/ICartModel';
import { Locale } from '../Locale';
import Body from './Body';
import Coupon from '../Coupon';
import Collapse from '@material-ui/core/Collapse';
import { IS_ECOMMERCE } from 'settings';
import Translate from 'components/Translate';

const styles = require('./priceQuantity.css');

interface IState extends IStateBase {
  cart: IProductData;
  circle?: boolean;
  payment: ICartModel;
  showDetails: boolean;
  feeInstallment: number;
}

export default class PriceQuantity extends BaseComponent<IState, {}> {

  componentDidMount() {
    const feeObservable = cartService.getCart().map(c => c.feeInstallment).distinctUntilChanged();

    this.observeState({ feeInstallment: null }, feeObservable);
    this.observeState({ cart: null }, cartService.getCart());
    this.observeState({ payment: null }, paymentService.getCart());

  }

  setShowDetails = () => {
    this.setState({ showDetails: !this.state.showDetails });
  }

  render() {
    if (!this.state) {
      return null;
    }
    const { cart, showDetails, feeInstallment } = this.state;

    return (
      <div className={styles.component}>

        <h3 className='title'>{cart.title}</h3>

        <div className={`details ${this.setShowDetails ? 'reverse' : ''}`}>
          <div
            className='showDetails'
            onClick={this.setShowDetails}
          >
            {showDetails
              ? <Translate term='Esconder Detalhes' />
              : <Translate term='Detalhes do evento' />
            }
          </div>
          <Collapse in={showDetails}>
            <Locale />
          </Collapse>
        </div>

        {!IS_ECOMMERCE
          ? <div>
            <Body />
            <Divider />
          </div>
          : <div className='descriptionQuantity'>
            {cart.products[0].description}
            <Divider />
          </div>
        }

        <div className={`coupon_price ${!cart.config.hasCoupon ? 'just_price' : ''}`} >
          <Coupon />
          <div className='price theme-label'>
            <span className='total'>Total:</span>
            <div id='final_price' className='value'>R$ {cart.price.toFixed(2).replace('.', ',')}</div>
            {feeInstallment === 0 ? <span className='chk-no-fee'><Translate term='SEM JUROS' /></span> : ''}
          </div>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/PriceQuantity/index.tsx